var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePayroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.428,
    viewBox: "0 0 20 20.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8851",
    "data-name": "Group 8851",
    transform: "translate(-0.195 0.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 20,
    height: 20,
    transform: "translate(0.195 0.195)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8506",
    "data-name": "Group 8506",
    transform: "translate(5.821 -0.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M1732.445,3977.725l.361.049a2.543,2.543,0,0,1,2.232,2.124,2.512,2.512,0,0,1-.553,2.14,2.328,2.328,0,0,1-1.406.77,2.887,2.887,0,0,1-2.107-.442,2.309,2.309,0,0,1-1.088-1.654,2.574,2.574,0,0,1,1.413-2.742,2.5,2.5,0,0,1,.907-.218.879.879,0,0,0,.138-.027Z",
    transform: "translate(-1728.253 -3977.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1729.837,4011.787a4.539,4.539,0,0,0-4.109-2.611h-.212a4.539,4.539,0,0,0-4.109,2.611Z",
    transform: "translate(-1721.407 -4003.204)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1713.7,4026.771h-11.289c-.01,0-.058.005-.135.015a.462.462,0,0,0-.114-.015h-1.813a1.912,1.912,0,0,0-1.91,1.91v5.532a1.912,1.912,0,0,0,1.91,1.91H1713.7a1.709,1.709,0,0,0,1.892-1.489v-6.373A1.709,1.709,0,0,0,1713.7,4026.771Zm-6.222,5.407a3.8,3.8,0,0,0-.683-.217,6.279,6.279,0,0,1-.842-.27,1.508,1.508,0,0,1-.577-.428,1.17,1.17,0,0,1-.245-.78,1.318,1.318,0,0,1,.386-.946,1.918,1.918,0,0,1,1.021-.531v-.787h.966v.759a3.538,3.538,0,0,1,.745.183,1.9,1.9,0,0,1,.559.307l-.393.9a2.965,2.965,0,0,0-.677-.328,2.1,2.1,0,0,0-.656-.114.913.913,0,0,0-.507.125.4.4,0,0,0-.19.352.34.34,0,0,0,.121.266.837.837,0,0,0,.3.166q.179.059.511.142a6.1,6.1,0,0,1,.828.249,1.366,1.366,0,0,1,.566.421,1.2,1.2,0,0,1,.235.78,1.314,1.314,0,0,1-.383.952,1.892,1.892,0,0,1-1.032.518v.78h-.966v-.752a3.458,3.458,0,0,1-.825-.162,2.4,2.4,0,0,1-.659-.328l.393-.9a2.61,2.61,0,0,0,1.45.435q.759,0,.759-.483A.325.325,0,0,0,1707.476,4032.178Zm6.2-4.458a.962.962,0,0,1,.961.96v.764h-.385a1.917,1.917,0,0,1-1.905-1.724Zm-14.241.96a.962.962,0,0,1,.961-.96h1.329a1.917,1.917,0,0,1-1.905,1.724h-.385Zm.961,6.492a.962.962,0,0,1-.961-.96v-.764h.385a1.917,1.917,0,0,1,1.905,1.724Zm14.241-.96a.962.962,0,0,1-.961.96h-1.329a1.917,1.917,0,0,1,1.905-1.724h.385Z",
    transform: "translate(-1696.977 -4017.691)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePayroll);
export default __webpack_public_path__ + "static/media/white_payroll.1f1acce9a86379b51c560473840392d9.svg";
export { ForwardRef as ReactComponent };